export default "__VITE_ASSET__3Waz0kmf__"